import React from "react";
import PropTypes from "prop-types";
import {Images} from "assets/images/imageData";
import "./style.css"

const FilesListView = ({ data = []}) => {

    const fileTypeIcon = (extn) => {
        switch(extn) {
            case "mp4":
                return Images.VideoIcon;
            case "png" || "jpg" || "jpeg":
                return Images.ImageIcon;
            case "pdf":
                return Images.PdfIcon;
            default:
                return Images.FolderIcon;
        }
    }

  return (
    <div className="files-wrapper">
        {data.length > 0 ?
            <ul className="files-list">
                {data.map((item) => 
                    <li>
                        <a target="_blank" href={item.document} rel="noreferrer">
                            <figure>
                                <img src={fileTypeIcon(item.ext)} alt={item.name} />
                            </figure>
                            
                            <div className="name">{item.name}</div>
                            <div className="type">Type: {item.type}</div> 
                        </a>
                    </li>
                )}
            </ul>
            : <div>No Files</div>
        }
    </div>
  );
};

FilesListView.propTypes = {
    data: PropTypes.array,
};

export { FilesListView };
export default FilesListView;
